var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "card w-modal h-modal", attrs: { id: "donation-details" } },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "title" }, [
          _c("div", { staticClass: "flex flex-col" }, [
            _c("h1", { staticClass: "mb-2" }, [_vm._v("New Donation")]),
            _c("div", { staticClass: "flex flex-row" }, [
              _c("h4", { staticClass: "opacity-50" }, [
                _vm._v("Supporter Details")
              ]),
              _c("h4", { staticClass: "ml-4 mr-4" }, [_vm._v(">")]),
              _c("h4", [_vm._v("Donation Details")]),
              _vm.showBbmsPopup
                ? _c("h4", { staticClass: "ml-4 mr-4" }, [_vm._v(">")])
                : _vm._e(),
              _vm.showBbmsPopup ? _c("h4", [_vm._v("Payment")]) : _vm._e()
            ])
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          },
          [_c("i", { staticClass: "icn icn-x sm" })]
        )
      ]),
      _vm.isLoadingForm
        ? _c("div", { staticClass: "content" }, [_vm._m(0)])
        : _vm._e(),
      !_vm.isLoadingForm
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _c("div", { staticClass: "field" }, [
                _c("label", [_vm._v("Donation Source")]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.donationSource,
                            expression: "payload.donationSource"
                          }
                        ],
                        attrs: { required: "", name: "donation-source" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.payload,
                              "donationSource",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [_vm._v("Select a donation source")]
                        ),
                        _c("option", { attrs: { value: "Phone call" } }, [
                          _vm._v("Phone call")
                        ]),
                        _c("option", { attrs: { value: "Mail post" } }, [
                          _vm._v("Mail post")
                        ])
                      ]
                    )
                  ])
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    !_vm.payload.donationProductDetails
                      ? _c("input", {
                          attrs: {
                            disabled: "",
                            value: "No product found",
                            type: "text"
                          }
                        })
                      : _vm._e(),
                    _vm.payload.donationProductDetails
                      ? _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.payload.donationProductDetails,
                                expression: "payload.donationProductDetails"
                              }
                            ],
                            attrs: { name: "product" },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.payload,
                                    "donationProductDetails",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.updateDonationSettings()
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.allProducts, function(product, index) {
                            return _c(
                              "option",
                              { key: index, domProps: { value: product } },
                              [_vm._v(" " + _vm._s(product.productname) + " ")]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ]),
                _vm.payload.donationProductDetails
                  ? _c("div", { staticClass: "row mt-2" }, [_vm._m(1)])
                  : _vm._e(),
                _c("div", { staticClass: "field" }, [
                  _c("div", { staticClass: "row mt-2" }, [
                    _c("input", {
                      attrs: { disabled: "", type: "text" },
                      domProps: {
                        value: _vm.toTitleCase(
                          _vm.payload.donationProductDetails.producttype
                        )
                      }
                    })
                  ])
                ]),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "field" }, [
                    _vm.payload.donationProductDetails.donationtypes
                      ? _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.payload.donation.type,
                                expression: "payload.donation.type"
                              }
                            ],
                            attrs: {
                              disabled:
                                _vm.payload.donationProductDetails.donationtypes
                                  .length == 1
                            },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.payload.donation,
                                    "type",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function($event) {
                                  return _vm.getMinDonationAmount()
                                }
                              ]
                            }
                          },
                          _vm._l(
                            _vm.payload.donationProductDetails.donationtypes,
                            function(donationType) {
                              return _c(
                                "option",
                                {
                                  key: donationType,
                                  domProps: {
                                    value: donationType,
                                    selected:
                                      _vm.payload.donation.type === donationType
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.parseDonationType(donationType)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e()
                  ])
                ]),
                _vm.payload.donationMinAmount
                  ? _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", [_vm._v("Minimum")]),
                        _c("input", {
                          attrs: { disabled: "", type: "text" },
                          domProps: {
                            value: "$" + _vm.payload.donationMinAmount
                          }
                        })
                      ])
                    ])
                  : _vm._e(),
                _vm.hasPackages
                  ? _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", [_vm._v("Packages")]),
                        _c("div", { staticClass: "flex flex-row ml-8 mt-2" }, [
                          _c(
                            "div",
                            { staticClass: "flex flex-col justify-start" },
                            _vm._l(
                              _vm.payload.donationProductDetails.packages,
                              function(pack, index) {
                                return _c(
                                  "label",
                                  { key: index },
                                  [
                                    pack.display
                                      ? _c("div", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.selectedPackageIndex,
                                                expression:
                                                  "selectedPackageIndex"
                                              }
                                            ],
                                            staticClass: "mr-2",
                                            attrs: {
                                              id: pack.code,
                                              type: "radio"
                                            },
                                            domProps: {
                                              value: index,
                                              checked: _vm._q(
                                                _vm.selectedPackageIndex,
                                                index
                                              )
                                            },
                                            on: {
                                              change: [
                                                function($event) {
                                                  _vm.selectedPackageIndex = index
                                                },
                                                function($event) {
                                                  return _vm.updatePackageCode()
                                                }
                                              ]
                                            }
                                          }),
                                          _vm._v(
                                            " " + _vm._s(pack.display) + " "
                                          )
                                        ])
                                      : _c("Alert", {
                                          attrs: {
                                            message: _vm.errorPackage(pack.code)
                                          }
                                        })
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm.payload.donationProductDetails.producttype === "adoption" &&
              _vm.hasPackages
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.payload.donation.isGift,
                              expression: "payload.donation.isGift"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.payload.donation.isGift)
                              ? _vm._i(_vm.payload.donation.isGift, null) > -1
                              : _vm.payload.donation.isGift
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.payload.donation.isGift,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.payload.donation,
                                        "isGift",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.payload.donation,
                                        "isGift",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.payload.donation, "isGift", $$c)
                                }
                              },
                              function($event) {
                                return _vm.clearGiftDetails()
                              }
                            ]
                          }
                        }),
                        _vm._v(" Make this a gift for someone ")
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.showGiftDetails
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "w-1/4" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.payload.gift.title,
                              expression: "payload.gift.title"
                            }
                          ],
                          attrs: { required: "" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.payload.gift,
                                "title",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "", disabled: "" } }, [
                            _vm._v("Select a title")
                          ]),
                          _c("option", { attrs: { value: "Mr" } }, [
                            _vm._v("Mr")
                          ]),
                          _c("option", { attrs: { value: "Mrs" } }, [
                            _vm._v("Mrs")
                          ]),
                          _c("option", { attrs: { value: "Ms" } }, [
                            _vm._v("Ms")
                          ]),
                          _c("option", { attrs: { value: "Miss" } }, [
                            _vm._v("Miss")
                          ]),
                          _c("option", { attrs: { value: "Dr" } }, [
                            _vm._v("Dr")
                          ]),
                          _c("option", { attrs: { value: "Mx" } }, [
                            _vm._v("Mx")
                          ])
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm.showGiftDetails
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.gift.firstName,
                            expression: "payload.gift.firstName"
                          }
                        ],
                        attrs: {
                          required: "",
                          type: "text",
                          placeholder: "First name",
                          autocomplete: "nope",
                          maxlength: "127"
                        },
                        domProps: { value: _vm.payload.gift.firstName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.payload.gift,
                              "firstName",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.gift.lastName,
                            expression: "payload.gift.lastName"
                          }
                        ],
                        attrs: {
                          required: "",
                          type: "text",
                          placeholder: "Last name",
                          autocomplete: "nope",
                          maxlength: "127"
                        },
                        domProps: { value: _vm.payload.gift.lastName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.payload.gift,
                              "lastName",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm.showGiftDetails
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.payload.donation.isGiftAtSameAddress,
                              expression: "payload.donation.isGiftAtSameAddress"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(
                              _vm.payload.donation.isGiftAtSameAddress
                            )
                              ? _vm._i(
                                  _vm.payload.donation.isGiftAtSameAddress,
                                  null
                                ) > -1
                              : _vm.payload.donation.isGiftAtSameAddress
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a =
                                    _vm.payload.donation.isGiftAtSameAddress,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.payload.donation,
                                        "isGiftAtSameAddress",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.payload.donation,
                                        "isGiftAtSameAddress",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.payload.donation,
                                    "isGiftAtSameAddress",
                                    $$c
                                  )
                                }
                              },
                              function($event) {
                                return _vm.copyGiftAddress()
                              }
                            ]
                          }
                        }),
                        _vm._v(
                          " The gift is to be delivered to the supporter address "
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm.needGiftAddress
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "field" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.payload.giftAddress.country,
                              expression: "payload.giftAddress.country"
                            }
                          ],
                          attrs: { name: "country" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.payload.giftAddress,
                                  "country",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.clearGiftAddress()
                              }
                            ]
                          }
                        },
                        _vm._l(_vm.countries, function(country, index) {
                          return _c(
                            "option",
                            { key: index, domProps: { value: country } },
                            [_vm._v(" " + _vm._s(country) + " ")]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e(),
              _vm.needGiftAddress &&
              _vm.payload.giftAddress.country === _vm.australia
                ? _c(
                    "div",
                    { staticClass: "row mt-2" },
                    [
                      _c("autocomplete-address", {
                        key: _vm.giftFullAddressKey,
                        on: { addressSelected: _vm.getGiftSelectedAddress }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.needGiftAddress
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.giftAddress.unitNumber,
                            expression: "payload.giftAddress.unitNumber"
                          }
                        ],
                        attrs: {
                          type: "text",
                          placeholder: "Unit number",
                          autocomplete: "nope"
                        },
                        domProps: { value: _vm.payload.giftAddress.unitNumber },
                        on: {
                          change: function($event) {
                            return _vm.updateGiftAddress()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.payload.giftAddress,
                              "unitNumber",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.giftAddress.streetNumber,
                            expression: "payload.giftAddress.streetNumber"
                          }
                        ],
                        attrs: {
                          required: "",
                          type: "text",
                          placeholder: "Street number",
                          autocomplete: "nope"
                        },
                        domProps: {
                          value: _vm.payload.giftAddress.streetNumber
                        },
                        on: {
                          change: function($event) {
                            return _vm.updateGiftAddress()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.payload.giftAddress,
                              "streetNumber",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm.needGiftAddress
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.giftAddress.streetName,
                            expression: "payload.giftAddress.streetName"
                          }
                        ],
                        attrs: {
                          required: "",
                          type: "text",
                          placeholder: "Street name",
                          autocomplete: "nope"
                        },
                        domProps: { value: _vm.payload.giftAddress.streetName },
                        on: {
                          change: function($event) {
                            return _vm.updateGiftAddress()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.payload.giftAddress,
                              "streetName",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.giftAddress.suburb,
                            expression: "payload.giftAddress.suburb"
                          }
                        ],
                        attrs: {
                          required: "",
                          type: "text",
                          placeholder: "Suburb",
                          autocomplete: "nope"
                        },
                        domProps: { value: _vm.payload.giftAddress.suburb },
                        on: {
                          change: function($event) {
                            return _vm.updateGiftAddress()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.payload.giftAddress,
                              "suburb",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm.needGiftAddress
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payload.giftAddress.postalCode,
                            expression: "payload.giftAddress.postalCode"
                          }
                        ],
                        attrs: {
                          required: "",
                          type: "text",
                          placeholder: "Postcode",
                          autocomplete: "nope"
                        },
                        domProps: { value: _vm.payload.giftAddress.postalCode },
                        on: {
                          change: function($event) {
                            return _vm.updateGiftAddress()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.payload.giftAddress,
                              "postalCode",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _c("div", { staticClass: "field" }, [
                      _vm.payload.giftAddress.country === _vm.australia
                        ? _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.payload.giftAddress.state,
                                  expression: "payload.giftAddress.state"
                                }
                              ],
                              attrs: { required: "", name: "state" },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.payload.giftAddress,
                                      "state",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.updateGiftAddress()
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "",
                                    disabled: "",
                                    selected: ""
                                  }
                                },
                                [_vm._v("Select a state")]
                              ),
                              _c("option", { attrs: { value: "NSW" } }, [
                                _vm._v("NSW")
                              ]),
                              _c("option", { attrs: { value: "ACT" } }, [
                                _vm._v("ACT")
                              ]),
                              _c("option", { attrs: { value: "NT" } }, [
                                _vm._v("NT")
                              ]),
                              _c("option", { attrs: { value: "SA" } }, [
                                _vm._v("SA")
                              ]),
                              _c("option", { attrs: { value: "WA" } }, [
                                _vm._v("WA")
                              ]),
                              _c("option", { attrs: { value: "VIC" } }, [
                                _vm._v("VIC")
                              ]),
                              _c("option", { attrs: { value: "QLD" } }, [
                                _vm._v("QLD")
                              ]),
                              _c("option", { attrs: { value: "TAS" } }, [
                                _vm._v("TAS")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm.payload.giftAddress.country !== _vm.australia
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.payload.giftAddress.state,
                                expression: "payload.giftAddress.state"
                              }
                            ],
                            attrs: {
                              type: "text",
                              placeholder: "State",
                              autocomplete: "nope"
                            },
                            domProps: { value: _vm.payload.giftAddress.state },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.payload.giftAddress,
                                  "state",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        : _vm._e()
                    ])
                  ])
                : _vm._e(),
              _vm._m(2),
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "row mt-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payload.donation.amount,
                        expression: "payload.donation.amount"
                      }
                    ],
                    attrs: {
                      required: "",
                      type: "number",
                      min: _vm.payload.donationMinAmount
                        ? _vm.payload.donationMinAmount
                        : 0.01,
                      step: ".01"
                    },
                    domProps: { value: _vm.payload.donation.amount },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.payload.donation,
                          "amount",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm.payload.donationProductDetails.dollarhandles &&
              Array.isArray(
                _vm.payload.donationProductDetails.dollarhandles[
                  _vm.payload.donation.type
                ]
              )
                ? _c("div", { staticClass: "row mt-2" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", [_vm._v("Dollar Handle Ranges")]),
                      _c("div", { staticClass: "row mt-2" }, [
                        _c(
                          "div",
                          { staticClass: "flex flex-col" },
                          _vm._l(
                            _vm.payload.donationProductDetails.dollarhandles[
                              _vm.payload.donation.type
                            ],
                            function(dollar, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "flex items-center mb-2"
                                },
                                [
                                  _c("img", {
                                    class: _vm.isInDollarHandleRange(dollar)
                                      ? "rounded border-2 w-24 mr-2 border-primary-500"
                                      : "rounded border-2 w-24 mr-2 border-gray-200",
                                    attrs: {
                                      src:
                                        "https://donate.wwf.org.au" +
                                        dollar.img,
                                      alt: "Image does not exists"
                                    }
                                  }),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "dollar-handle mr-2 flex-1",
                                      class: _vm.isInDollarHandleRange(dollar)
                                        ? "primary"
                                        : "secondary",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.changeDonationAmountTo(
                                            dollar.amount
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" $" + _vm._s(dollar.amount) + " ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      class: _vm.isInDollarHandleRange(dollar)
                                        ? "font-bold flex-1"
                                        : "flex-1"
                                    },
                                    [_vm._v(" " + _vm._s(dollar.text) + " ")]
                                  )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "field mt-4" }, [
                _c("h2", [_vm._v("Payment mode")]),
                _c("div", { staticClass: "flex flex-col gap-y-2 ml-8 mt-2" }, [
                  _c("label", { staticClass: "flex flex-row items-center" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.paymentType,
                          expression: "paymentType"
                        }
                      ],
                      staticClass: "mr-2",
                      attrs: { id: "creditCard", type: "radio" },
                      domProps: {
                        value: _vm.creditCard,
                        checked: _vm._q(_vm.paymentType, _vm.creditCard)
                      },
                      on: {
                        change: [
                          function($event) {
                            _vm.paymentType = _vm.creditCard
                          },
                          function($event) {
                            return _vm.changePaymentModeTo(_vm.creditCard)
                          }
                        ]
                      }
                    }),
                    _vm._v(" Credit Card ")
                  ]),
                  _c("label", { staticClass: "flex flex-row items-center" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.paymentType,
                          expression: "paymentType"
                        }
                      ],
                      staticClass: "mr-2",
                      attrs: { id: "directDebit", type: "radio" },
                      domProps: {
                        value: _vm.directDebit,
                        checked: _vm._q(_vm.paymentType, _vm.directDebit)
                      },
                      on: {
                        change: [
                          function($event) {
                            _vm.paymentType = _vm.directDebit
                          },
                          function($event) {
                            return _vm.changePaymentModeTo(_vm.directDebit)
                          }
                        ]
                      }
                    }),
                    _vm._v(" Direct Debit ")
                  ])
                ])
              ]),
              _vm.showBbmsPopup
                ? _c("BbmsCreditCardForm", {
                    on: {
                      success: _vm.processDonation,
                      close: function($event) {
                        _vm.showBbmsPopup = false
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.isLoadingForm
        ? _c("div", { staticClass: "footer" }, [
            _c(
              "button",
              {
                staticClass: "secondary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.$emit("previousStep")
                  }
                }
              },
              [_vm._v("Back")]
            ),
            _c("div", { staticClass: "flex-grow" }),
            _c(
              "button",
              {
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.goToNextStep()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.processButtonLabel) + " ")]
            )
          ])
        : _vm._e(),
      _vm.errorMessage
        ? _c("Alert", { attrs: { message: _vm.errorMessage } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-col justify-center items-center h-full" },
      [
        _c("img", {
          staticClass: "h-36",
          attrs: { src: require("@/assets/img/loading.svg") }
        }),
        _c("h2", [_vm._v("Loading")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field" }, [
      _c("label", [_vm._v("Gift Type")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-2" }, [
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v("Donation Amount")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }